export default {
    demo(){ console.log('hola desde core/demo') },
    
    setShowAside(context, showAside){
      context.commit('SET_SHOWASIDE', showAside);  
    },
}
